export const LOGIN_LOADING = 'login/getLogin/loading';
export const LOGIN_SUCCESS = 'login/getLogin/success';
export const LOGIN_ERROR = 'login/getLogin/error';
export const LOGIN_LOGOUT = 'login/getLogin/logout';